import { message } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import CustomText from '../../CustomText';

function ReferralLinks({ refData = [] }) {

  const copyReferralLink = (referralLink) => {
    if (referralLink && navigator?.clipboard) {
      navigator.clipboard.writeText(referralLink);
      message.success('Copied link to clipboard!')
    }
  }

  return (
    <div className="ant-list-box table-responsive" style={{ maxHeight: 400 }}>
      <table className="width-100">
        <thead>
          <tr>
            <th>Link</th>
            <th>Campaign Title</th>
            <th>Campaign ID</th>
          </tr>
        </thead>
        <tbody>
          {refData && refData.map((data) => {
            return (
              <tr>
                <td>
                  <CustomText
                    dataSet={data}
                    property1={'link'}
                  />&nbsp;&nbsp;
                  <CopyOutlined onClick={() => copyReferralLink(data?.link)} style={{ cursor: 'pointer'}}/>
                </td>
                <td>
                  <CustomText
                    dataSet={data}
                    property1={'campaignTitle'}
                  />
                </td>
                <td>
                  <CustomText
                    dataSet={data}
                    property1={'campaignId'}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default ReferralLinks;
